---
en:
  work_items:
    add_attachment: Add attachment
    attachments: Attachments
    average_cost_per_closed_work_item: Average cost per closed task
    average_days_to_close_work_item: Average days to close task
    budget_cost: Budget cost
    closed_tasks: Closed tasks
    closed_work_items: Closed tasks
    due_date: Due date
    error_deleting: There was an error deleting this work item
    filter_responsibles: Filter responsibles
    forecast_cost: Forecast cost
    history: History
    label_in_use: Used by {count} task. Contact support to change it. | Used by {count} tasks. Contact support to change it.
    label_in_use_error:
      one: This tag is used by one task, so only support can change it.
      other: This tag is used by %{count} tasks, so only support can change it.
    model_name: Task
    move: Move
    moved_work_item_from: moved task from
    new_label: New label
    no_attachments: No attachments
    not_allowed_to_delete: You can only delete your own work items
    number_of_projects: Number of projects
    number_of_work_items: Number of tasks
    open_work_items: Open tasks
    opened_work_item: opened task
    project_status: Project status
    reassigned_work_item_from: reassigned task from
    show_closed_tasks: Show closed tasks
    show_on_hold_tasks: Show on hold tasks
    show_only_closed_tasks: Show only closed tasks
    show_only_on_hold_tasks: Show only on hold tasks
    started_on: Started on
    status:
      closed: Closed
      in_progress: In progress
      on_hold: On hold
      open: Open
    sum_total_cost: Sum Total Cost
    today: Today
    total_budget_cost: Total budget cost
    total_closed_cost: Total closed cost
    total_closed_cost_by_month: Total closed task cost by month
    total_cost_by_month: Total task cost
    total_in_progress_cost: Total in progress cost
    total_open_cost: Total open cost
    total_open_cost_by_month: Total open task cost by month
    validations:
      select_power_plant_first: Please select power plant first
    work_item_labels: Task labels
    work_item_total_cost_by_month: Total task cost by month
    work_items_by_component: Task percentage by component
    work_items_by_status_by_month: Open and closed tasks by month
